import PricingManagement from "./Management";
import Settings from "./Configuration";
import PriceChanges from "./PriceChanges";
import BuyBoxReport from "./BuyBoxReport";
import type { RouteDefinition } from "../../routes/routes";
import { ParentAsinManagementPage } from "./ParentAsinManagement";
import Forecast from "./Forecast";
import InventoryDashboard from "./InventoryDashboard";
import PricingDashboardV4 from "./DashboardV4";
import PricingPlanPageV2 from "./PricingPlanV2";

export const PricingV2Routes: RouteDefinition[] = [
  {
    path: "/_pricing",
    layout: "/user",
    application: "Pricing",
    children: [
      {
        path: `/user/_pricing/management`,
        component: PricingManagement,
        exact: true,
      },
      {
        path: "/user/_pricing/management/category/:category/",
        component: PricingManagement,
        exact: true,
      },
      {
        path: `/user/_pricing/dashboard`,
        component: PricingDashboardV4,
        exact: true,
      },
      {
        path: `/user/_pricing/dashboard/category/:category`,
        component: PricingDashboardV4,
        exact: true,
      },
      {
        path: `/user/_pricing/inventory`,
        component: InventoryDashboard,
        exact: true,
      },
      {
        path: "/user/_pricing/plan/:plan",
        component: PricingPlanPageV2,
        exact: true,
      },
      {
        path: "/user/_pricing/configuration",
        component: Settings,
        exact: true,
      },
      {
        path: "/user/_pricing/changes",
        component: PriceChanges,
        exact: true,
      },
      {
        path: "/user/_pricing/buybox",
        component: BuyBoxReport,
        exact: true,
      },
      {
        path: "/user/_pricing/:parentAsin/manage",
        component: ParentAsinManagementPage,
        exact: true,
      },
      {
        path: "/user/_pricing/forecast",
        component: Forecast,
        exact: true,
      },
    ],
  },
];
